import React from "react";
import Vendor from "./Vendor";

const UserManagement = () => {
  return (
      <Vendor />
  );
};

export default UserManagement;
